<footer>
    <p>This site is designed to be used for training purposes at SoftUni.</p>
    <p>You can find the real SoftUni forum at this link:</p>
    <p><span><a href="https://softuni.bg/forum">https://softuni.bg/forum</a></span> Angular course Copyright &copy;
        2020</p>
</footer>